import React, { useEffect, useMemo, useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import { get, isEmpty } from "lodash";
import { fourPlaceHolder, groupSlots } from "modules/utilities/utility";
import CardDiv from "modules/common/card-div/CardDiv";
import moment from "moment";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useConsultDoctor } from "../actionables/store";
import useStatsStore from "modules/engagement_report/engagement_stats/store";

function EditTicketInterventionCanvas({ name, email, phone, selectedSlot, setSelectedSlot, selectedDate, setSelectedDate, setTicketObject, filterSlotData, setFilterSlotData, doctorMed, setDoctorMed, doctorSubCategoryFlag = false }) {
  const { bookedData, slotData, allSlotData, bookedLoading, allSlotLoading, fetchOnboardingData, fetchDoctorSlotData } = useConsultDoctor();
  const [formData] = useState({
    first_name: name,
    email: email,
    phone_number: phone,
  });
  const { users, fetchUserData } = useStatsStore();

  const interventionDocList = useMemo(() => {
    return users
    ?.filter((doctor) => get(doctor, ['user', 'meta', 'is_intervention_doctor'], false) && get(doctor, 'user_id', false) && get(doctor,['user', 'first_name'], false))
    .map((doctor) =>({ label: doctor.user.first_name, value: doctor.user_id }));
  }, [users]);

  
  useEffect(() => {
    if (doctorSubCategoryFlag && !isEmpty(bookedData) && doctorMed) {
      fetchDoctorSlotData(bookedData?.caseId, doctorMed, null, toast);
    }
    else{
      setFilterSlotData([]);
    }
  }, [bookedData]);

  useEffect(() => {
    if ((doctorSubCategoryFlag || doctorMed)  && !isEmpty(bookedData)) {
      const groupSlot = groupSlots(slotData);
      setFilterSlotData(groupSlot);
    } else {
      setFilterSlotData([]);
    }
  }, [slotData, allSlotData]);

  const handleDate = (date) => {
    setSelectedDate(date);
    setSelectedSlot(null);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    fetchOnboardingData({ ...formData, gender: "M" }, toast);
  };

  useEffect(() => {
    if (selectedSlot) {
      const selectedSlotPayload = {
        from_crm: true,
        case_id: bookedData?.caseId,
        transaction_id: bookedData?.transactionId,
        consult_doctor_fees: "0",
        slot_time: selectedSlot?.slotTime,
        slots: selectedSlot?.slots,
      };
      setTicketObject(selectedSlotPayload);
    }
  }, [selectedSlot]);

  return (
    <>
      <div>
        <div className="text-center">
        {doctorSubCategoryFlag ? <Form onSubmit={handleSubmit}>
          <Form.Select
              name="from_crm"
              required
              aria-label="Default select example"
              onChange={(event) => setDoctorMed(event.target.value)}
            >
              <option value="">Please Select Doctor</option>
              {interventionDocList?.map((doctor) => {
                return <option value={doctor?.value}>{doctor?.label}</option>;
              })}
            </Form.Select>
            <Button type="submit" className="w-25 mt-4 py-2 text-center">
              {bookedLoading ? (
                <span className="d-flex flex-row gap-2 justify-content-center">
                  <Spinner animation="border" variant="light" />
                  <span>Submitting</span>
                </span>
              ) : (
                <span> Submit</span>
              )}
            </Button>
          </Form> : null}
        </div>
        {allSlotLoading ? fourPlaceHolder() : null}
        <div className="d-flex gap-2 flex-wrap justify-content-center mt-3">
          {filterSlotData &&
            Object.keys(filterSlotData)?.map((slotDate) => {
              return (
                <div
                  className="cursor-pointer"
                  onClick={() => handleDate(slotDate)}
                >
                  <CardDiv
                    title={
                      <div
                        className={
                          slotDate == selectedDate
                            ? "text-primary fw-bold"
                            : "fw-bold"
                        }
                      >
                        {moment(slotDate).format("ddd DD")}
                      </div>
                    }
                    component={
                      <div
                        className={
                          slotDate == selectedDate
                            ? "text-primary fw-bold"
                            : "fw-bold"
                        }
                      >
                        {slotDate}
                      </div>
                    }
                  />
                </div>
              );
            })}
        </div>
        <div
          className="d-flex gap-3 flex-wrap mt-5 scrollable-container"
          style={{ maxHeight: "50vh", overflowY: "scroll" }}
        >
          {selectedDate &&
            filterSlotData[selectedDate]?.map((timeSlot) => {
              return (
                <Button
                  style={{ width: "100px" }}
                  onClick={() => setSelectedSlot(timeSlot)}
                  className={
                    timeSlot?.slots?.count === 0
                      ? " py-2 fs-1 bg-secondary text-white rounded-5 cursor-na disabled pointer-events-none text-center"
                      : selectedSlot?.slotTime == timeSlot?.slotTime
                      ? "py-2 fs-1 bg-success text-white rounded-5 cursor-pointer text-center"
                      : " py-2 fs-1 rounded-5  bg-white text-black border border-secondary cursor-pointer text-center"
                  }
                >
                  {moment(timeSlot?.slotTime).format("hh:mm A")}
                </Button>
              );
            })}
        </div>
      </div>
    </>
  );
}

export default EditTicketInterventionCanvas;
